// React
import { useState } from 'react';

// Components
import { UsersPage } from '@Pages/UsersPage';
import { CampaignsPage } from '@Pages/Campaigns';
import { RoundsRoute } from '@Routes/RoundsRoute';
import { ProvidersRoute } from '@Routes/ProvidersRoute/ProvidersRoute';
import { TransactionPage } from '@Pages/TransactionPage/TransactionPage';
import { ICONS } from '@Components/layouts/dashboard/nav/config-navigation';
import { LocalizationsPage } from '@Pages/LocalizationsPage';
import { TestsPage } from '@Pages/TestsPage/TestsPage';

export type RouteConfig = {
  path: string;
  component: React.ComponentType;
  title: string;
  icon: JSX.Element;
  routePermission: string[];
};

export const useRoles = () => {
  const [setAvailableRoutes] = useState([]);
  const [loading] = useState(true);

  const allRoutes: RouteConfig[] = [
    {
      path: '/providers',
      component: ProvidersRoute,
      title: 'Providers',
      icon: ICONS.user,
      routePermission: ['CAN_VIEW_PROVIDERS'],
    },
    {
      path: '/rounds',
      component: RoundsRoute,
      title: 'Rounds',
      icon: ICONS.pricing,
      routePermission: ['CAN_VIEW_AVIATOR_ROUNDS'],
    },
    {
      path: '/transactions',
      component: TransactionPage,
      title: 'Transactions',
      icon: ICONS.navTransactions,
      routePermission: ['CAN_VIEW_PROVIDER_TRANSACTIONS', 'CAN_VIEW_AVIATOR_ROUND_TRANSACTIONS'],
    },
    {
      path: '/users',
      component: UsersPage,
      title: 'Users',
      icon: ICONS.roles,
      routePermission: ['CAN_VIEW_BACKOFFICE_USERS', 'CAN_VIEW_BACKOFFICE_ROLES'],
    },
    {
      path: '/campaigns',
      component: CampaignsPage,
      title: 'Campaigns',
      icon: ICONS.rentals,
      routePermission: ['CAN_VIEW_FREEBETS', 'CAN_VIEW_FREEBETS_CAMPAIGNS'],
    },
    {
      path: '/languages',
      component: LocalizationsPage,
      title: 'Languages',
      icon: ICONS.file,
      routePermission: ['CAN_VIEW_LOCALIZATIONS'],
    },
    {
      path: '/tests',
      component: TestsPage,
      title: 'Tests',
      icon: ICONS.analytics,
      routePermission: ['CAN_RUN_TESTS'],
    },
  ];

  return {
    loading,
    allRoutes,
    setAvailableRoutes,
  };
};
